// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const Error429Style = styled('div')(
  () => css`
    .error-429 {
      background-color: #1a1768;
      color: #ffffff;
      min-height: 100vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .error-429-header {
        background-image: url('../../../assets/img/error/error-429-header-background.png');
        min-height: 450px;
        background-size: cover;
        background-position: bottom center;
        display: flex;
        align-items: flex-end;

        .header-image {
          text-align: center;
          margin: 4em auto 0;
          position: relative;

          .img {
            position: relative;
            max-width: 100%;
            z-index: 2;
          }

          .shadow {
            position: absolute;
            width: 900px;
            height: 400px;
            object-fit: cover;
            z-index: 1;
            left: 0;
            right: 0;
            bottom: -170px;
            margin: 0 auto;
            max-width: 100%;
          }
        }
      }

      .error-429-content {
        margin-top: 2rem;
        position: relative;
        z-index: 3;
        text-align: center;

        .content-title {
          font-size: 1.5rem;
          font-weight: 700;
          text-align: center;
        }

        .content-description {
          font-size: 0.95rem;
          font-weight: 700;
          line-height: 1.7rem;
          text-align: center;
          margin: 0 auto;
          padding: 0 2rem;
        }

        .content-logout {
          margin-top: 45px;
        }
      }

      .error-429-logo {
        flex-grow: 1;
        display: flex;
        align-items: flex-end;
        justify-content: center;

        .logo-image {
          margin-bottom: 4rem;
        }
      }
    }

    @media (max-width: 900px) {
      .error-429 {
        .error-429-header {
          min-height: 400px;

          .header-image {
            .img {
              max-width: 550px;
            }
          }
        }
        .error-429-content {
          .content-description {
            padding: 0 6rem;
          }
        }
      }
    }

    @media (max-width: 800px) {
      .error-429 {
        .error-429-header {
          .header-image {
            .img {
              max-width: 500px;
            }
          }
        }
      }
    }

    @media (max-width: 700px) {
      .error-429 {
        .error-429-header {
          min-height: 380px;

          .header-image {
            .img {
              max-width: 70%;
            }
          }
        }
      }
    }

    @media (max-width: 600px) {
      .error-429 {
        .error-429-header {
          min-height: 350px;
        }

        .error-429-content {
          .content-title {
            font-size: 1.2rem;
          }

          .content-description {
            font-size: 0.75rem;
            line-height: 1.5rem;
            padding: 0 4rem;
          }
        }
      }
    }
  `
);
